class SiteSelector extends HTMLElement {
  constructor() {
    super();

    // Prevent modal on Shopify robot challenge page
    if (window.location.pathname === '/challenge') {
      return;
    }

    this.cookieName = 'beyours:site-selector';

    this.classes = {
      bodyClass: 'site-selector--open',
      activeClass: 'is-active',
      closingClass: 'is-closing'
    };

    this.modal = this.querySelector('.site-selector');

    this.querySelectorAll('[data-site-choice]').forEach((button) => {
      button.addEventListener('click', this.onChoice.bind(this));
    });

    this.querySelectorAll('[data-site-close]').forEach((button) => {
      button.addEventListener('click', this.onDismiss.bind(this));
    });

    // La fenêtre ne s'affiche plus tant que le choix est enregistré
    if (!this.getCookie(this.cookieName) || this.dataset.testMode === 'true') {
      this.init();
    }
  }

  connectedCallback() {
    if (window.Shopify && Shopify.designMode) {
      this.onShopifySectionSelect = this.onSectionSelect.bind(this);
      this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
      document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }

  disconnectedCallback() {
    if (window.Shopify && Shopify.designMode) {
      document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
      document.body.classList.remove(this.classes.bodyClass);
    }
  }

  onSectionSelect(event) {
    if (event.detail && event.detail.sectionId === this.dataset.sectionId) this.open();
  }

  onSectionDeselect(event) {
    if (event.detail && event.detail.sectionId === this.dataset.sectionId) this.close();
  }

  init() {
    if (!this.modal) {
      return;
    }

    if (window.Shopify && Shopify.designMode) {
      return;
    }

    setTimeout(function () {
      this.open();
    }.bind(this), parseInt(this.dataset.delay) * 1000);
  }

  onChoice(event) {
    event.preventDefault();

    // Dans l'éditeur de thème : on ferme sans enregistrer ni rediriger
    if (window.Shopify && Shopify.designMode) {
      this.close();
      return;
    }

    const button = event.currentTarget;
    const choice = button.dataset.siteChoice;
    const link = button.dataset.siteLink;

    // Enregistre l'information (choix du visiteur)
    if (this.dataset.testMode !== 'true') {
      this.setCookie(this.cookieName, choice, this.dataset.expiry);
    }

    // Redirection éventuelle (ex : site Professionnels)
    if (link) {
      window.location.href = link;
      return;
    }

    this.close();
  }

  onDismiss(event) {
    event.preventDefault();

    // Dans l'éditeur de thème : simple fermeture
    if (window.Shopify && Shopify.designMode) {
      this.close();
      return;
    }

    // Ferme sans choix mais mémorise, pour ne pas réafficher la fenêtre
    if (this.dataset.testMode !== 'true') {
      this.setCookie(this.cookieName, 'dismissed', this.dataset.expiry);
    }

    this.close();
  }

  open() {
    this.modal.classList.add(this.classes.activeClass);

    if (this.modal.dataset.position === 'center') {
      document.body.classList.add(this.classes.bodyClass);
    }
  }

  close() {
    this.modal.classList.add(this.classes.closingClass);

    setTimeout(() => {
      this.modal.classList.remove(this.classes.activeClass);
      this.modal.classList.remove(this.classes.closingClass);

      if (this.modal.dataset.position === 'center') {
        document.body.classList.remove(this.classes.bodyClass);
      }
    }, 500);

    // En mode test, on retire le cookie éventuellement posé
    if (this.dataset.testMode === 'true') {
      this.removeCookie(this.cookieName);
    }
  }

  getCookie(name) {
    const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return match ? match[2] : null;
  }

  setCookie(name, value, expiry) {
    document.cookie = `${name}=${value}; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
  }

  removeCookie(name) {
    document.cookie = `${name}=; max-age=0`;
  }
}
customElements.define('site-selector', SiteSelector);
